import ChatRoom from './ChatRoom';
import { FaLocationDot } from "react-icons/fa6";


const ChatPopup = ({ seller, isOpen, setIsOpen }) => {

    if(!seller) return null

    return (
        <>
            <button
                className="floatingChatButton"
                onClick={() => setIsOpen(!isOpen)}
            >
                <img src={seller?.profileImage} alt="Error" />
                <div className="chatFloatRight">
                    <div>Message {seller?.displayName.split(' ')[0]}</div>
                    <div className='chatFloatLower'><FaLocationDot />{seller?.country}</div>
                </div>
            </button>
            {isOpen && (
                <div className={`chatPopupDiv ${isOpen ? 'open' : ''}`}>
                    <ChatRoom
                        participant={seller?.userId}
                        sellerParticipant={seller}
                        isParticipantAdmin={false}
                        isPopup={true}
                        onClose={() => setIsOpen(false)}
                    />
                </div>
            )}
        </>
    );
};

export default ChatPopup;